import { render, staticRenderFns } from "./User-addons.vue?vue&type=template&id=60db2740&scoped=true"
import script from "./User-addons.vue?vue&type=script&lang=js"
export * from "./User-addons.vue?vue&type=script&lang=js"
import style0 from "./User-addons.vue?vue&type=style&index=0&id=60db2740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60db2740",
  null
  
)

export default component.exports